import ConvertSDK from '@convertcom/js-sdk';
import { CONVERT_ACCOUNT_ID, CONVERT_FULLSTACK_PROJECT_ID } from '../utils';

const sdkConfig = {
  sdkKey: `${CONVERT_ACCOUNT_ID}/${CONVERT_FULLSTACK_PROJECT_ID}`,
  environment: 'production',
};

const convertSdk = new ConvertSDK(sdkConfig);
export default convertSdk;
